export const estruturasRoute: string = 'estruturas';
export const estruturasModuleName: any = {plural: 'Estruturas', single: 'Estrutura'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/shared/data.service.ts
 **/